import { Component, OnInit } from '@angular/core';

import { CookiesService } from 'src/app/services/app/cookie.service';
import { iRole } from 'src/app/entities/app/role.model';
import { iPermission } from 'src/app/entities/app/permissions.model';
import { RoleService } from 'src/app/services/shared/role.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { SignContractModalComponent } from 'src/app/contracts/sign-contract-modal/sign-contract-modal.component';
import { ContractProvider } from 'src/app/providers/contracts/contracts.prov';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
  public menu: iPermission[] = [];
  public homeItems: iPermission[] = [];
  public rol;

  constructor(
    private cookiesServ: CookiesService,
    private roleServ: RoleService,
    private routeActive: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private contractProv: ContractProvider,
  ) {
    this.menu = this.cookiesServ.getMenu();
    const data = this.cookiesServ.getData()
    this.rol = data && data.user && data.user.rol;

    //Verificar si es estudiante
    if (this.rol.name == "Estudiante" && parseInt(data.user.semester) > 1) {
      //Consultar si ya tiene firmada la carta compromiso
      this.contractProv.isSigned(data.user.email).subscribe((res) => {
        if (!res.isSigned) {
          Swal.fire({
            title: '',
            html: "<h5>Atención: Estimado estudiante te invitamos a consultar el nuevo reglamento que ostenta tus obligaciones y derechos como estudiante del  TECNM en el siguiente <a target='_blank' href='https://www.tepic.tecnm.mx/doc/Reglamento_de_Estudiantes_del_TecNM.html'>enlace</a></h5><br><h5>Posteriormente debes firmar la carta compromiso y consentimiento para poder continuar en tu sesión.</h5>",
            type: 'warning',
            showCancelButton: true,
            cancelButtonColor: '#d33',
            confirmButtonColor: '#3085d6',
            cancelButtonText: 'Salir',
            confirmButtonText: 'Continuar',
            allowOutsideClick: false,
            allowEscapeKey: false,
            width: '90%'
          }).then((res) => {
            if (res.dismiss) {
              this.logOut();
            }
            if (res.value) {
              this.signContract();
            }
          });
        }
      });
    }

    if (this.rol.name == "Estudiante") {
      Swal.fire({
        title: '<span style="color: #F26622;">Información para Estudiantes</span>',
        html: `
          <img src="assets/mitec/mensajecursosingles.png" 
          alt="Aviso de Cursos de Ingles"
          style="width:100%; max-height:500px; object-fit:contain;" />
        `,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#183969',
        allowOutsideClick: false,
        allowEscapeKey: false,
        width: 'auto',
        heightAuto: false,
      });
    }
  }

  ngOnInit() {
    this.homeItems = this._generateHomeItems(this.menu);
    this.roleServ.changeRole
      .subscribe((role: iRole) => {
        this.homeItems = (role && role.permissions) ? this._generateHomeItems(<iPermission[]>role.permissions) : [];
      });
  }

  public logOut() {
    this.cookiesServ.deleteStorageData();
    window.location.replace('/');
  }

  public async signContract() {
    const dialogRef = this.dialog.open(SignContractModalComponent, {
      data: {
        student: this.cookiesServ.getData()
      },
      disableClose: true,
      hasBackdrop: true,
      width: '99%',
      height: '99%'
    });

    dialogRef.afterClosed().subscribe(_ => {
      console.log(_);
    });
  }

  private _generateHomeItems(menu: iPermission[]): iPermission[] {
    let homeItems = [];
    let _currentCategory = '';
    let _categoryItems = [];
    if (menu && menu.length) {
      menu.forEach(permission => {
        if (_currentCategory.toLowerCase() !== (permission.category || '').toLowerCase() && _categoryItems && _categoryItems.length) {
          homeItems = _categoryItems.length > 1 ? homeItems.concat(_categoryItems) : homeItems;
          _categoryItems = [];
        }
        _currentCategory = permission.category || '';
        if (permission.label.toLowerCase() !== 'perfil' && permission.label.toLowerCase() !== 'inicio') {
          _categoryItems.push(permission);
        }
      });
      if (_categoryItems && _categoryItems.length) {
        homeItems = _categoryItems.length > 1 ? homeItems.concat(_categoryItems) : homeItems;
      }
    }
    return homeItems;
  }

}
